import script from "./goRinSyo0012.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0012.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0012.vue?vue&type=style&index=0&id=2ff8ca7b&lang=scss"

const __exports__ = script;

export default __exports__